// 发短信
import axiosRequest from '@/utils/request'

export const smsLogin = (data) => {
  return axiosRequest({
    url: '/wallet/sms-login',
    data,
    method: 'post'
  })
}

// 登录注册接口
export const userLogin = (data) => {
  return axiosRequest({
    url: '/wallet/user-login',
    data,
    method: 'post',
    showMessage: false
  })
}
